import Glide, {
  Controls,
  Breakpoints,
  Swipe
} from '@glidejs/glide/dist/glide.modular.esm'

export default {
  init () {
    this.gallery()
  },

  gallery () {
    const onChange = (objToWatch, onChangeFunction) => {
      const handler = {
        set (target, property, value, receiver) {
          if (property === 'index') onChangeFunction()
          return Reflect.set(target, property, value)
        }
      }
      return new Proxy(objToWatch, handler)
    }

    const galerias = document.querySelectorAll('.galeria-mg')
    let gals = []

    Object.values(galerias).map((galeria, idx) => {
      galeria.setAttribute(`data-idx`, idx)

      // Slides
      const ul = galeria.querySelector('.glide__slides')
      let cLi = 0
      for (let i = 0; i < ul.childNodes.length; i++)
        if (ul.childNodes[i].nodeName === 'LI') cLi++

      //  Bullets
      let controlsDiv = galeria.querySelector('.glide__bullets')
      let buttonsHtml = ``
      for (let i = 0; i < cLi; i++) {
        buttonsHtml += `<button class="glide__bullet" data-glide-dir="=${i}" data-idx="${i}"></button>`
      }
      controlsDiv.innerHTML = buttonsHtml

      // Init Gallerys
      const glide = new Glide(galeria, {
        gap: 20,
        startAt: 0
      })
      const proxyGlide = onChange(glide, () => {
        const urlArray = document.URL.split('/').filter(x => x !== '')

        const materia = '/'.concat(urlArray[urlArray.length - 1], '?galeria=1')

        ga('send', 'pageview', materia)
      })
      gals[`${idx}`] = proxyGlide
      proxyGlide.mount({ Controls, Breakpoints, Swipe })
    })

    // Update Bullets
    let itemBullets = document.querySelectorAll('.glide__bullets')
    itemBullets.forEach((element, indexGal) => {
      element.childNodes.forEach((item, indexBullet) => {
        item.addEventListener('click', function (e) {
          gals[indexGal].update({ startAt: indexBullet })
          console.log(gals[indexGal])
          console.log(indexBullet)
        })
      })
    })
  }
}
